import { ActionDropdown } from 'common'
import Card from 'components/Card'
import Table from 'components/Table'
import Button from 'components/common/buttons/Button'
import API_HOST from 'consts'
import withDownloadButton from 'hoc/withDownloadButton'
import React, { useCallback, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { toast } from 'react-toastify'
import { useReport, useReportData } from 'reports/hooks'

type Props = {
  onDownload: ( data: { api: string; filename: string } ) => Promise<undefined>
}

const ReportViewPage = ( { onDownload }: Props ) => {
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const [page, setPage] = useState( 1 )
  const { data: report, isLoading: isLoadingReport } = useReport( +id )
  const { data: reportData, isLoading: isLoadingReportData } = useReportData(
    +id,
    page
  )

  const exportReportData = useCallback( async () => {
    const progressToast = toast.info(
      'Seu relatório está sendo exportado. Por favor aguarde!',
      { autoClose: false, position: toast.POSITION.BOTTOM_RIGHT }
    )

    await onDownload( {
      api: `${API_HOST}/reports/sql_reports/${id}/excel`,
      filename: `Relatório - ${report?.name}.xlsx`,
    } )

    toast.update( progressToast, {
      type: toast.TYPE.SUCCESS,
      autoClose: 5000,
      render: 'Relatório exportado com sucesso!',
    } )
  }, [report] )

  const handleAction = ( action: string ) => {
    switch ( action ) {
      case 'EXPORT_EXCEL':
        exportReportData()
    }
  }

  return (
    <Card title={report?.name} loading={isLoadingReport}>
      <ActionDropdown
        className="d-flex justify-flex-end mb-1"
        onClick={handleAction}
        actions={[{ value: 'EXPORT_EXCEL', label: 'Exportar para excel' }]}
      />
      <Table
        onPageChange={( p: number ) => setPage( p + 1 )}
        sortable={false}
        pageSize={10}
        showPageSizeOptions={false}
        pages={reportData?.total_pages}
        data={reportData?.results}
        loading={isLoadingReportData}
        manual={true}
        resizable={true}
        isResponsive
        columns={report?.headers?.map( ( header ) => ( {
          Header: header.toUpperCase(),
          accessor: header.toLowerCase(),
          minWidth: 300
        } ) )}
      />
      <div className="d-flex justify-flex-end mt-1">
        <Button onClick={() => history.push( '/relatorios' )} action="link">
          Voltar
        </Button>
      </div>
    </Card>
  )
}

export default withDownloadButton( ReportViewPage )
